import { createContext, useContext } from 'react';

export const AuthContext = createContext();

export const useAuth = () => {
  const user = useContext(AuthContext);
  if (user === undefined) {
    throw new Error(
      `user is UNDEFINED.
      1. useAuthState out of scope, must be called inside provider.
      2. The user object passed to context - from redux - is undefined.`
    );
  }
  if (Object.keys(user).length === 0 && user.constructor === Object) {
    return null;
  }

  return user;
};
